module.exports = __webpack_public_path__ + "img/img125.28e68b8a.svg";